import { render, staticRenderFns } from "./ChartDonut.vue?vue&type=template&id=58081278&"
import script from "./ChartDonut.vue?vue&type=script&lang=js&"
export * from "./ChartDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports